"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgBell = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M30 26v-5a6 6 0 10-12 0v5c0 .729-.195 1.412-.535 2h13.07A3.982 3.982 0 0130 26zm-3.768 6.135a1 1 0 01.363 1.367 3 3 0 01-5.19 0 1 1 0 011.666-1.101l.064.097a1 1 0 001.73 0 1 1 0 011.367-.363zM24 13a8 8 0 018 8v5a2 2 0 002 2c1.333 0 1.333 2 0 2H14c-1.333 0-1.333-2 0-2a2 2 0 002-2v-5a8 8 0 018-8z",
    id: "bell_svg__a"
  }));
};

var _default = SvgBell;
exports.default = _default;